export const EVENTS_SCHEMA_VERSION = "0.43.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.17.0";
